var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import ClearIcon from "@mui/icons-material/Clear";
import { Button } from "@mui/material";
export function DashboardClearFiltersButton(_a) {
    var onClick = _a.onClick, disabled = _a.disabled, _b = _a.testId, testId = _b === void 0 ? "dashboard-filter-clear" : _b, _c = _a.label, label = _c === void 0 ? "Limpar filtros" : _c;
    return (_jsx(Button, __assign({ size: "small", variant: "outlined", startIcon: _jsx(ClearIcon, { sx: { fontSize: "16px !important" } }), disabled: disabled, "data-testid": testId, onClick: onClick, sx: {
            borderRadius: "10px",
            textTransform: "none",
            fontFamily: "Montserrat, sans-serif",
            fontWeight: 600,
            fontSize: "0.78rem",
            color: "#6B7280",
            borderColor: "#E5E7EB",
            minHeight: 40,
            "&:hover": {
                borderColor: "#034EA2",
                color: "#034EA2",
            },
        } }, { children: label })));
}
